import {
  CloseCircleOutlined,
  PlusCircleFilled,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Row,
  Table,
  Tooltip,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import search from "../../helpers/search";
import useEyeLevelSettings from "../../hooks/useEyeLevelSettings";
import { eye_level_setting_default } from "./types";
import { eyeLevelSettingsService } from "../../services/EyeLevelSettingsService";
import EyeLevelSettingsForm from "../EyeLevelSettingsPage/EyeLevelSettingsForm";
import moment from "moment";
import { structureEyeLevel } from "./Eyelevelutil";

const { Header, Content } = Layout;

export const getFullDate = (date: string): string => {
  const dateAndTime = date.split("T");
  let format_date = moment.utc(date).local();
  return format_date.format("YYYY-MM-DD");
};

const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date: string) => getFullDate(date),
  },
  {
    title: "Manufacturer",
    dataIndex: "manufacturer_name",
    key: "manufacturer_name",
  },
  {
    title: "Country",
    dataIndex: "country_name",
    key: "country_name",
  },
  {
    title: "Category",
    dataIndex: "category_name",
    key: "category_name",
  },
];
const EyeLevelSettingsPage: React.FC = function () {
  const [form] = useForm();
  const [searching, setSearching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [channelsToDisplay, setChannelsToDisplay] = useState([]);
  const [selected, setSelected] = useState(structureEyeLevel(eye_level_setting_default))
  const [state, setState] = useState({
    isCreate: false,
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    pagination_search: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [channels, loadingChannels] = useEyeLevelSettings(
    state.pagination.current
  );
  const onSearch = async (key: string) => {
    const { searchWord } = await form.getFieldsValue();
    if (!searchWord) {
      message.error("Please enter a valid search string!");
      return;
    }

    setSearching(true);
    // made array to cater more query types in future
    const searchData = [
      {
        key,
        value: encodeURIComponent(searchWord),
        collection: "eye_level_settings",
      },
    ];

    const searchedData = await search(searchData, eyeLevelSettingsService, key);
    setChannelsToDisplay(searchedData.data);
    setState({
      ...state,
      pagination_search: {
        ...state.pagination_search,
        total: searchedData.total,
        current: 1,
      },
    });
    setSearching(false);
  };

  const onClose = async () => {
    const { searchWord } = await form.getFieldsValue();

    setState({
      ...state,
    });
    setSearching(true);
    if (searchWord) {
      const searchData = [
        {
          key: "manufacturer_name",
          value: encodeURIComponent(searchWord),
          collection: "eye_level_settings",
        },
      ];

      const searchedData = await search(
        searchData,
        eyeLevelSettingsService,
        "manufacturer_name"
      );
      setChannelsToDisplay(searchedData.data);
    } else {
      const searchedData = await eyeLevelSettingsService.getAll(
        state.pagination.current
      );
      const data_channelsToDisplay = searchedData.data.eye_level_settings
        ? searchedData.data.eye_level_settings
        : channels;
      setChannelsToDisplay(data_channelsToDisplay);
    }

    setSearching(false);
  };

  const handleTableChange = async (pagination: any) => {
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination: pagination,
    });
    const data = await eyeLevelSettingsService.getAll(pagination.current);
    setChannelsToDisplay(data.data.eye_level_settings);
    setSearching(false);
  };

  const handleTableSearchChange = async (pagination: any) => {
    const { searchWord } = await form.getFieldsValue();

    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination_search: pagination,
    });
    const searchData = [
      {
        key: "manufacturer_name",
        value: encodeURIComponent(searchWord),
        page: pagination.current,
        collection: "eye_level_settings",
      },
    ];

    const data = await search(
      searchData,
      eyeLevelSettingsService,
      "manufacturer_name"
    );
    setChannelsToDisplay(data.data);
    setSearching(false);
  };

  useEffect(() => {
    setChannelsToDisplay(channels.eye_level_settings);
    setState({
      ...state,
      pagination: {
        ...state.pagination,
        total: channels.total,
      },
    });
  }, [channels]);

  const loading = searching || loadingChannels;

  return (
    <Layout style={{ padding: 20 }}>
      <Header
        style={{
          textAlign: "left",
          backgroundColor: "#F0F2F5",
          padding: 0,
          borderRadius: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <h3 style={{ fontWeight: "bold", paddingLeft: 0 }}>
              Eye Level Settings
            </h3>
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingRight: 0 }}>
            <Button
              onClick={() => {
                setVisible(true);
                setState({
                  ...state,
                  isCreate: true,

                });
                setSelected(structureEyeLevel(eye_level_setting_default))
              }}
              type="primary"
              shape="round"
              icon={<PlusCircleFilled />}
              style={{ width: 150 }}
            >
              Add New
            </Button>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row
          style={{
            textAlign: "left",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginTop: 0,
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24} style={{ fontWeight: "bold" }}>
                What are you looking for?
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Form
                form={form}
                initialValues={{ searchWord: "" }}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexWrap: "wrap",
                }}
                onValuesChange={(changedVals) => {
                  if (changedVals.searchWord === "") {
                    onClose();
                  }
                }}
              >
                <Col>
                  <Form.Item name="searchWord">
                    <Input
                      style={{ width: 300, borderRadius: 10 }}
                      placeholder={"Search"}
                      prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                      suffix={
                        <Tooltip title="Clear Search">
                          <CloseCircleOutlined
                            onClick={() => {
                              setChannelsToDisplay(channels.eye_level_settings);
                              setState({
                                ...state,
                                isCreate: false,
                                pagination: {
                                  current: 1,
                                  pageSize: 10,
                                  total: channels.total,
                                },
                              });
                              form.setFieldsValue({
                                searchWord: ""
                              });
                            }}
                            style={{
                              color: "rgba(0,0,0,.45)",
                            }}
                          />
                        </Tooltip>
                      }
                    ></Input>
                  </Form.Item>

                </Col>
                <Col style={{ textAlign: "right", paddingRight: 0 }}>
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      type="primary"
                      shape="round"
                      onClick={() => onSearch("manufacturer_name")}
                      style={{ width: 200 }}
                    >
                      Search By Manufacturer
                    </Button>
                  </Form.Item>

                </Col>
              </Form>

            </Row>
          </Col>
        </Row>
        <Row
          style={{
            padding: 20,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 15,
          }}
        >
          <Col span={24}>
            {!form.getFieldValue("searchWord") ? (
              <Table
                //pagination={{ position: ["bottomRight", "topRight"] }}
                pagination={state.pagination}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        isCreate: false,
                      });
                      setSelected(structureEyeLevel(record))
                      setVisible(true);
                    },
                  };
                }}
                dataSource={channelsToDisplay}
                columns={columns}
                onChange={handleTableChange}
              />
            ) : (
              <Table
                pagination={state.pagination_search}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        isCreate: false,
                      });
                      setSelected(structureEyeLevel(record))
                      setVisible(true);
                    },
                  };
                }}
                dataSource={channelsToDisplay}
                columns={columns}
                onChange={handleTableSearchChange}
              />
            )}
          </Col>
        </Row>
      </Content>
      <EyeLevelSettingsForm
        visible={visible}
        values={selected}
        isChanged={false}
        setVisible={setVisible}
        isCreate={state.isCreate}
        onClose={onClose}
      />
    </Layout>
  );
};

export default EyeLevelSettingsPage;
